<template>
  <div ref="self"
    class="l-row module kv"
    :class="{'s--right': data.target.width == 3, 'kv--layout0': data.target.layout == 0,'kv--layout1': data.target.layout == 1,'kv--layout2': data.target.layout == 2,'kv--layout3': data.target.layout == 3}"
    :data-color-anchor="`1,0.3,#${data.color[0]},#${data.color[1]},#${data.color[1]},#171010,#F9F5EF,#F9F5EF`"
  >
    <div class="kv__inr">
      <div v-show="data.target.layout == 3" class="c-pic kv__img i--3">
        <Picture class="c-pic__img" :src="data.target.src" :parallax="data.target.parallax == 0 ? false : true" :from="data.target.from" :embedType="data.target.embedType" :ratio="data.target.ratio" />
      </div>
      <div v-show="data.target.layout == 2" class="c-pic kv__img i--2">
        <Picture class="c-pic__img" :src="data.target.src" :parallax="data.target.parallax == 0 ? false : true" :from="data.target.from" :embedType="data.target.embedType" :ratio="data.target.ratio"/>
        <div class="c-pic__desc">
          <div class="t-h--13 t-h--11s">
            <span class="t--fak c-pic__desc--info" v-html="data.visualCaption"></span>
          </div>
        </div>
      </div>
      <div class="kv__tit-wrap kv__tit-wrap--top">
        <div v-if="!(data.isFront && (data.target.layout == 0 || data.target.layout == 1 || data.target.layout == 3))" class="kv__tit kv__tit--brand i--brand">
          <div class="t-h--128 t-h--200l t-h--54s">
            <span class="t--fak">{{ data.brand }}</span>
          </div>
        </div>
        <div v-show="data.target.layout == 1" class="c-pic kv__img i--1">
          <Picture class="c-pic__img" :src="data.target.src" :parallax="data.target.parallax == 0 ? false : true" :from="data.target.from" :embedType="data.target.embedType" :ratio="data.target.ratio" />
          <div class="c-pic__desc">
            <div class="t-h--13 t-h--11s">
              <span class="t--fak c-pic__desc--info" v-html="data.visualCaption"></span>
            </div>
          </div>
        </div>
        <div v-if="!(data.isFront && (data.target.layout == 0 || data.target.layout == 3))" class="kv__tit i--project-type">
          <div class="t-h--128 t-h--200l t-h--54s">
            <span class="t--fak">{{ data.type }}</span>
          </div>
        </div>
      </div>
      <div v-show="data.target.layout == 0" class="c-pic kv__img i--0">
        <!-- <img class="c-pic__img" :src="data.target.src ? require(`@/assets${data.target.src}`) : require(`@/assets/common/blank.gif`)" alt="" /> -->
        <!-- <img class="c-pic__img" :src="data.thumbnail ? require(`@/assets${data.thumbnail}`) : require(`@/assets/common/blank.gif`)" alt="" /> -->
        <!-- <video class="c-pic__img" autoplay loop muted><source :src="data.target.src ? data.target.src : require(`@/assets/common/blank.gif`)" type="video/mp4"></video> -->
        <Picture class="c-pic__img" :src="data.target.src" :parallax="data.target.parallax == 0 ? false : true" :from="data.target.from" :embedType="data.target.embedType" :ratio="data.target.ratio" />
        <!-- <div class="c-pic__img c-embed">
          <iframe class="c-embed__item" width="560" height="315" src="https://www.youtube.com/embed/FnaMkjKQ-1w?controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div> -->
        <div class="c-pic__desc l-mdl--4 l-mdl--8l">
          <div class="t-h--13 t-h--11s">
            <span class="t--fak c-pic__desc--info" v-html="data.visualCaption"></span>
          </div>
        </div>
      </div>
      <div class="kv__tit-wrap kv__tit-wrap--bottom">
        <div class="kv__pic-desc c-pic__desc">
          <div class="t-h--13 t-h--11s">
            <span class="t--fak c-pic__desc--info" v-html="data.visualCaption"></span>
          </div>
        </div>
        <div class="s--right kv__tit kv__tit--year">
          <div class="t-h--128 t-h--200l t-h--54s">
            <span class="t--fak">©{{ methods.getLaunchingYear() }}</span>
          </div>
        </div>
        <div class="c-sep">
          <div class="g-row c-sep__item--label label">
            <div class="g-col--12 g-col--3s label__tit">
              <div class="g-row">
                <div class="g-col--5 g-col--3s">
                  <div class="t-h--13 t-h--11s label__brand"><div class="t--fak">{{ data.brand }} </div></div>
                </div>
                <div class="g-col--6">
                  <div class="t-h--13 t-h--11s label__type"><div class="t--fak" data-swap=".label__brand|append|.label__type|append"><span class="t--ft">(</span><span>{{ data.type }}</span><span class="t--ft">)</span></div></div>
                </div>
                <div class="g-col--5 g-col--3s">
                  <div class="t-h--13 t-h--11s"><span class="t--fak">© {{ data.client }}</span></div>
                </div>
              </div>
            </div>
            <!-- <div class="g-col--6 g-col--3s label__cat">
              <div class="t-h--13 t-h--11s"><span class="t--fak">• TECHNOLOGY + SOFTWARE,</span></div>
              <div class="t-h--13 t-h--11s"><span class="t--fak">• DESIGN + ARCHITECTURE,</span></div>
              <div class="t-h--13 t-h--11s"><span class="t--fak">• B2B + PROFESSIONAL SERVICES</span></div>
            </div> -->
            <div class="g-col--3 g-col--2s s--right label__num">
              <div class="t-h--13 t-h--11s"><span class="t--ft">(</span><span class="t--fak">N°{{ data.pid }}</span><span class="t--ft">)</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="l-mdl--64 l-mdl--128l g-row s--h-start ov__headline i--ovHeadline">
      <div class="g-col--12 g-col--5s">
        <div class="t-h--54 t-h--28s">
          <span class="t--fak">{{ data.headline }}</span>
        </div>
      </div>
    </div>

    <div class="l-mdl--64 g-row s--h-between ov">
      <div class="g-col--3 g-col--5s ov__brief">
        <ul class="t-b--13 t-b--11s ov__cat">
          <li v-show="data.service.length > 0" v-for="(item, index) in data.service" :key="index" class="t--fak c-blt"><span class="c-blt__dot">•</span> {{ item.toUpperCase() }}</li>
          <li v-if="data.service.length == 0" class="t--fak c-blt"><span class="c-blt__dot">•</span> DISCIPLINES</li>
          <!-- <li class="t--fak c-blt">VISUAL LANGUAGE</li>
          <li class="t--fak c-blt">CONTENT DIRECTION</li>
          <li class="t--fak c-blt">WEBSITE DESIGN</li>
          <li class="t--fak c-blt">INTERACTIVE STYLE GUIDE</li> -->
        </ul>
        <div
          class="c-pic ov__img i--arrow-ov-img"
          data-swap=".ov__txt-wrap|append|.ov__brief|append"
        >
          <div class="c-pic__img i--ovImg">
            <component :is="data.websiteSet[0][1].length > 0 && data.websiteImg ? 'a' : 'div'" v-bind="data.websiteSet[0][1] ? { href:data.websiteSet[0][1], target: '_blank' } : {}" >
              <Picture :src="data.websiteImg" :parallax="false" />
            </component>
          </div>
          <div class="c-pic__desc i--ovLink">
              <div class="l-mdl--8 t-b--18 t-b--16s" v-for="(line, lineIndex) in data.websiteSet" :key="lineIndex">
                <a class="t--fak c-pic__desc--info c-arrow-effect" v-if="line[1]" :href="line[1]" target="_blank">
                  {{line[0]}} <ArrowButton dir="up"/>
                </a>
              </div>
              <div class="l-mdl--8 t-b--18 t-b--16s" v-if="data.websiteSet.length === 1">
                <span class="t--fak c-pic__desc--info dummy">
                  Link <span class="t--ft">(</span>↗<span class="t--ft">)</span>
                </span>
              </div>
          </div>
        </div>
      </div>
      <div class="g-col--10 g-col--2s ov__txt-wrap">
        <div
          class="g-row ov__txt"
          data-swap=".ov__brief|append|.ov__txt-wrap|append"
        >
          <div class="g-col--5">
            <div class="t-b--18 t-b--16s ov__story i--ovStory">
              <div class="ov__story-block" v-html="data.story"></div>
            </div>
          </div>
          <div class="g-col--5">
            <div class="t-b--18 t-b--16s l-mdl--16s ov__story-kr i--ovStoryKr">
              <div class="ov__story-block" v-html="data.koHeadlineWithStory"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="l-row--t128 module c-sep">
      <div class="g-row c-sep__item--label">
        <div class="g-col--6 g-col--2s">
          <div class="t-h--13"><span class="t--fak">BRAND</span></div>
        </div>
        <div class="g-col--8 g-col--3s">
          <div class="t-h--13">
            <span class="t--fak">
              <span class="t--ft">(</span>Design<span class="t--ft">)</span></span
            >
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import * as $ from "fxdom";
import * as _ from "fxjs";
import { computed, onMounted, onUnmounted, ref, reactive, watchEffect, useStore } from '@/helper/vue.js';
import { bindKeyEvent } from "@/helper/keyEvent.js";
import { addEvent } from '@/helper/event.js';
import { getDate, formatYear, moveElement } from "@/helper/gadget.js";
import Picture from "@/parts/picture/PictureView.vue";
import ArrowButton from "@/parts/button/ArrowButton.vue";
import { useRoute } from 'vue-router';

export default {
  name: 'Kv',
  props: ["idx", "bindRoot", "modalOpen"],
  components: {
    Picture,
    ArrowButton
  },
  setup(props) {
    const { state, get, commit } = useStore();
		const self = ref();
    const route = useRoute();
		const data = reactive({
      isFront: route.name == "project" ? true : false,
      color: computed(() => get["from"](`${props.bindRoot}.color`)),
			date: computed(() => get["from"](`${props.bindRoot}.date`)),
			brand: computed(() => get["from"](`${props.bindRoot}.brand`)),
			type: computed(() => get["from"](`${props.bindRoot}.type`)),
			thumbnail: computed(() => get["from"](`${props.bindRoot}.thumbnail`)),
      client: computed(() => get["from"](`${props.bindRoot}.client.name`)),
			service: computed(() => get["from"](`${props.bindRoot}.service`)),
      pid: computed(() => get["from"](`${props.bindRoot}.pid`)),
			visualCaption: computed(() => get["from"](`${props.bindRoot}.visualCaption`)),
			headline: computed(() => get["from"](`${props.bindRoot}.headline`)),
			headlineKo: computed(() => get["from"](`${props.bindRoot}.headlineKo`)),
      launching: computed(() => get["from"](`${props.bindRoot}.launching`)),
      websiteSet: computed(() => get["from"](`${props.bindRoot}.liveLink`)),
      websiteImg: computed(() => get["from"](`${props.bindRoot}.websiteImg`)),
			story: computed(() => get["from"](`${props.bindRoot}.story`)),
			storyKo: computed(() => get["from"](`${props.bindRoot}.storyKo`)),
			target: computed(() => get["from"](`${props.bindRoot}.modules.${props.idx}`)),
      koHeadlineWithStory: computed(() => (data.headlineKo ? data.headlineKo : "") + (data.storyKo ? data.storyKo : "")),
    });
		onMounted(() => {

      if (route.name === "project") {
        if (data.websiteImg === "") {
          $.setCss(
            {
              display: 'none'
            },
            $.qs(".i--ovImg", self.value)
          )
        }
        if (data.websiteSet.length === 1) {
          $.setCss(
            {
              display: 'none'
            },
            $.qs(".i--ovLink", self.value)
          )
        }
        if (data.websiteSet.length === 1 && data.websiteImg === "") {
          $.setCss(
            {
              display: 'none'
            },
            $.qs(".ov__img", self.value)
          )
        }
      }

      moveElement();
			window.addEventListener('changed.mq', () => {
        moveElement();
      });

    });
		onUnmounted(() => {
			window.removeEventListener('changed.mq', () => {
				moveElement();
      });
		});

    const methods = {
      getLaunchingYear: function () {
        return formatYear(getDate(data.launching.toString()).year)
      },
    }

    return {
			self,
      data,
      methods
    };
  },
};
</script>

<style scoped lang="scss">
.kv {
  $self: &;
  margin-bottom: 128em;
  .w1600__ & {
    margin-bottom: 256em;
  }
	&__img {
		margin-top: 4em;
		&:first-child {
			margin-top: 0;
		}
		&.i--1 {
			margin-top: 4em;
		}
		.__w600 & {
			margin-top: 4px;
		}
	}
	&__pic-desc {
		display: none;
	}
	.c-sep {
		border-top: none;
		&__item--label {
			margin-top: 0;
		}
	}
	.c-pic__desc {
    margin-top: 4em;
    .w1600__ & {
      margin-top: 8em;
    }
  }
  &--layout0 {
    .__w600 & {
      // padding-top: 96em;
    }
  }
	&--layout3 {
		max-width: 100%;
		#{$self} {
			&__inr {
				position: relative;
			}
			&__tit {
				&--year {
					margin-top: 8em;
				}
			}
			&__tit-wrap {
				position: absolute;
				left: 0;
				right: 0;
				max-width: var(--contentRow);
				margin-left: auto;
				margin-right: auto;
        z-index: 30;
				&--top {
					top: 48em;
				}
				&--bottom {
					bottom: 29em;
					.__w600 & {
						bottom: 18.5em;
					}
				}
			}
			&__pic-desc {
				display: block;
			}
		}
    .__w600 & .kv__img {
      margin-top: 0;
    }
		.kv__inr ~ .g-row {
			max-width: calc(var(--contentRow) + var(--gutter));
			margin-left: auto;
			margin-right: auto;
		}
	}
}
.label {
	&__tit {
		.__w600 & {
			.g-col--7 {
				display: none;
			}
		}
	}
	&__cat {
		.__w600 & {
			order: -1;
		}
	}
}

.ov {
	&__cat {
		margin-top: 4em;
		.__w600 & {
			float: right;
      width: var(--cw2);
			margin-left: var(--gutter);
			margin-bottom: 32em;
		}
		.c-blt {
      position: relative;
      padding-left: 0.7em;
      &__dot {
        position: absolute;
        top: 0;
        left: 0;
      }
			&::before {
				color: #171010;
			}
		}
	}
	&__img {
		margin-top: 32em;
		.c-pic__desc {
			margin-top: 0;
			padding-bottom: 0;
			&--info {
				&::before {
					display: none;
				}
			}
		}
		.__w600 & {
			margin-top: 64em;
		}
	}
  &__story-block {
    .t-block {
      .__w600 & {
        text-indent: calc(var(--unitScale) * 73px);
      }
    }
  }
  &__story.editable {
    .__w600 & {
      overflow: inherit;
    }
  }
	&__txt {
		.__w600 &.g-row {
			display: block;
		}	
	}
	.__w600 & {
		justify-content: flex-start;
		margin-top: 32em;
	}
}
</style>